import { SelectDesignTokens } from '@primeuix/themes/types/select';
import { SM_SIZE_TOKENS } from './sm-size.tokens';

export const SELECT_STYLES: SelectDesignTokens = {
  root: {
    sm: SM_SIZE_TOKENS,
  },
  dropdown: {
    width: '1.75rem',
  },
  css: ({ dt }) => `
    /* Keeps line-height proportional to the 13px font-size */
    .p-select-sm .p-select-label {
        line-height: 0.9375rem; /* 15px */
    }

    .p-select-sm .p-select-clear-icon {
        width: 0.75rem;
        height: 0.75rem;
    }

    /* Dropdown option font-size aligned with --p-select-sm-font-size (13px) */
    .p-select-sm .p-select-option {
        font-size: 0.8125rem; /* 13px */
    }

    /* Matches sm option size so the list looks consistent regardless of trigger size */
    .p-select-list-container .p-select-option {
        font-size: 0.8125rem; /* 13px */
    }

    .p-select.p-inputwrapper-filled input.p-placeholder {
        color: ${dt('surface.700')};
    }`,
};
